export function determineImageFormat(webpURL, jpgURL) {
    const supportsWebP = (() => {
      if (typeof window === 'undefined') {
        // If not in the browser environment, default to jpg
        return false;
      }
  
      const elem = document.createElement('canvas');
      return elem && elem.getContext && elem.toDataURL('image/webp').indexOf('data:image/webp') === 0;
    })();
  
    return supportsWebP ? webpURL : jpgURL;
  }
  